import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { IDraftEmail, ITemplateEmail, TemplateEmail, TemplateEmailInsert } from '../../../models/email-message';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { UserState } from '../../../state/user/user-state';
import { TemplateEmailState } from '../../../state/email/template-email-state';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { Message } from 'primeng/api';
import { EmailService } from "../../../services/email.service";
import { EmailTemplatesEditorComponent } from "../email-templates-editor/email-templates-editor.component";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-template-email-list',
  standalone: true,
  imports: [CommonModule, PanelModule, TableModule, ButtonModule, 
            OverlayPanelModule, FloatLabelModule, FormsModule, DropdownModule, 
            ButtonGroupModule, DialogModule, EditorModule, InputTextModule, 
            MessagesModule, EmailTemplatesEditorComponent],
  templateUrl: './template-email-list.component.html',
  styleUrl: './template-email-list.component.scss'
})
export class TemplateEmailListComponent implements OnInit {

  @ViewChild('templateEditor') editor!: OverlayPanel;
  @Input() allowApply: boolean = false;
  @Input() allowEdit: boolean = true;

  @Input() objectForTemplateApplication?: any;
  @Output() templateApplied: EventEmitter<IDraftEmail> = new EventEmitter<IDraftEmail>();
  currentUser$ = this._store.select(UserState.currentUser);
  templateEmails$ = this._store.select(TemplateEmailState.templateEmails);
  stateTemplateEmail$ = this._store.select(TemplateEmailState.templateEmail);
  messages: Message[] = [];
  nameExists: boolean = false;
  newEmailDialogVisible: boolean = false;
  selectedTemplate: ITemplateEmail = {} as ITemplateEmail;

  constructor
  (
    public _store: Store,
    private emailService: EmailService
  )
  {    
  }

  ngOnInit()
  {
    this.messages = [{ severity: 'info', detail: 'Template Name Already Exists'}];
  }



  newTemplateEmail()
  {
    this.selectedTemplate = {} as ITemplateEmail;
  }



  async applyButtonPressed(event:MouseEvent, email: TemplateEmail)
  {
    if (email && this.objectForTemplateApplication)
    {
      var appliedTemplateEmail = await this.emailService.applyTemplateEmail(email.id, this.objectForTemplateApplication);
      this.templateApplied.emit(appliedTemplateEmail);
    }
  }

  async saveButtonPressed(editedTemplate: ITemplateEmail)
  {
    //Is this a new template?
    if(editedTemplate instanceof TemplateEmail && editedTemplate.id != undefined && editedTemplate.id > 0)
    { 
      await this.emailService.saveTemplateEmail( editedTemplate.id, editedTemplate.asUpdate());
    }
    else
    {
      var newEmail : TemplateEmailInsert = new TemplateEmailInsert(editedTemplate.templateName,editedTemplate.subject,editedTemplate.body);
      await this.emailService.addTemplateEmail(newEmail);
    }


    this.editor.hide();
    this.selectedTemplate = {} as ITemplateEmail;

  } 
  
  cancelButtonPressed()
  {
    this.editor.hide();
    this.selectedTemplate = {} as ITemplateEmail;
  }

  deleteButtonPressed(event:MouseEvent, email: TemplateEmail)
  {
    this.emailService.deleteTemplateEmail(email.id);
  }

  containsCurlyBrackets(inputString: string)
  {
    const pattern = /\{\{\{.*?\}\}\}/;
    return pattern.test(inputString);
  }

  

}
  

